/* eslint-disable sonarjs/cognitive-complexity */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function contactPersonRowValidator(elemPrefix: string, personMandatory = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const nameControl = getControl(control, elemPrefix, 'Name');
        const emailControl = getControl(control, elemPrefix, 'Email');
        const phoneControl = getControl(control, elemPrefix, 'Phone');
        const phoneExtControl = getControl(control, elemPrefix, 'PhoneExt');
        if (!personMandatory) {
            if (hasValue(nameControl) || hasValue(emailControl) || hasValue(phoneControl) || hasValue(phoneExtControl)) {
                setAsRequired(nameControl);
                setAsRequired(emailControl);
            } else {
                setAsOptional(nameControl);
                setAsOptional(emailControl);
            }
        } else {
            if (hasValue(phoneControl) || hasValue(phoneExtControl)) {
                setAsRequired(nameControl);
                setAsRequired(emailControl);
            }
        }
        if (hasValue(phoneExtControl) && !hasValue(phoneControl)) {
            setAsRequired(phoneControl);
        } else {
            setAsOptional(phoneControl);
        }
        return null;
    };
}

function getControl(parent: AbstractControl, elemPrefix: string, id: string) {
    const control = parent.get(`${elemPrefix}${id}`);

    if (control === null) {
        throw new Error(`Could not find control '${elemPrefix}' id: ${id}`);
    }

    return control;
}

function hasValue(control: AbstractControl): boolean {
    return control.value !== '';
}

function setAsRequired(control: AbstractControl) {
    if (!hasValue(control)) {
        control.setErrors({ required: true });
    }

    control.markAsTouched();
}

function setAsOptional(control: AbstractControl) {
    delete control.errors?.['required'];
    if (Object.keys(control.errors ?? {}).length === 0) {
        control.setErrors(null);
    }
}
